function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var _container;
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    container: (_container = {
      position: 'relative',
      backgroundColor: colors.backgroundDarker,
      color: colors.gray,
      fontSize: '14px',
      flex: 1,
      textAlign: 'center',
      fontWeight: 300,
      textTransform: 'uppercase',
      textIndent: '25px'
    }, _defineProperty(_container, mediaQueries.breakpointTablet, {
      fontSize: 0
    }), _defineProperty(_container, '&.active', _defineProperty({
      backgroundColor: colors.primary,
      color: colors.white
    }, mediaQueries.breakpointTablet, {
      backgroundColor: colors.secondary
    })), _defineProperty(_container, '&:after', _defineProperty({
      content: '""',
      position: 'absolute',
      zIndex: 1,
      top: 0,
      right: '-42px',
      borderStyle: 'solid',
      borderWidth: '25px 25px 25px 15px',
      width: '42px',
      borderColor: "transparent transparent transparent ".concat(colors.backgroundDarker)
    }, mediaQueries.breakpointTablet, {
      content: 'none'
    })), _defineProperty(_container, '&.active:after', _defineProperty({
      borderColor: "transparent transparent transparent ".concat(colors.primary)
    }, mediaQueries.breakpointTablet, {
      content: 'none'
    })), _defineProperty(_container, '&:before', _defineProperty({
      content: '""',
      position: 'absolute',
      zIndex: 1,
      top: '-7px',
      right: '-53px',
      width: '53px',
      borderStyle: 'solid',
      borderWidth: '32px 34px 32px 19px',
      borderColor: "transparent transparent transparent ".concat(colors.background)
    }, mediaQueries.breakpointTablet, {
      content: 'none'
    })), _defineProperty(_container, '&.last:before', {
      content: 'none'
    }), _container)
  };
});